// src/App.js
import React from 'react';
import { perfMark } from './utils/perfTracker';
import './i18n';
import AppV3 from './v3/AppV3';
import V3ResourceLoader from './v3/components/V3ResourceLoader';
import { V3StateProvider } from './v3/V3StateContext';
import { AuthProvider } from './contexts/AuthContext';
import { LocaleProvider } from './contexts/LocaleContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { NetworkActivityProvider } from "./contexts/NetworkActivityContext";
import { SettingsDialogProvider } from './contexts/SettingsDialogContext';
import { GlobalSSEProvider } from './contexts/GlobalSSEContext';

// Initialize Telegram WebApp
if (window.Telegram?.WebApp) {
    const webApp = window.Telegram.WebApp;

    // Expand to full height
    webApp.expand();

    // Mark app as ready
    webApp.ready();

    console.log('[App] Telegram WebApp initialized', {
        version: webApp.version,
        platform: webApp.platform,
        isExpanded: webApp.isExpanded
    });

    // Store initialization info for later display
    window.__telegramInitInfo = {
        version: webApp.version,
        platform: webApp.platform
    };
}
perfMark('tgInit');

function AppContent() {
    return (
        <GlobalSSEProvider>
            <V3StateProvider>
                <V3ResourceLoader>
                    <AppV3 />
                </V3ResourceLoader>
            </V3StateProvider>
        </GlobalSSEProvider>
    );
}

function App() {
    return (
        <AuthProvider>
            <LocaleProvider>
                <SnackbarProvider>
                    <NetworkActivityProvider>
                        <SettingsDialogProvider>
                            <AppContent />
                        </SettingsDialogProvider>
                    </NetworkActivityProvider>
                </SnackbarProvider>
            </LocaleProvider>
        </AuthProvider>
    );
}

export default App;
